import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  selectAuditLogs,
} from "../../store/slices/auditTrailSlice";
import { formatDateTime } from "../../utils/date";

const AuditTable = ({ dense = false }) => {
  const rows = useSelector(selectAuditLogs);
  const theme = useTheme();
  const headerGradient =
    "linear-gradient(90deg, #030712 0%, #0f172a 50%, #111827 100%)";

  return (
    <TableContainer
      component={Box}
      sx={{ minWidth: "100%", width: "100%", overflowX: "auto" }}
    >
      <Table
        size={dense ? "small" : "medium"}
        sx={{ minWidth: 960, borderCollapse: "separate", borderSpacing: 0 }}
      >
        <TableHead
          sx={{
            background: headerGradient,
            "& th": {
              borderBottom: "none",
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: 0.3,
              color: theme.palette.common.white,
            },
            "& th:first-of-type": { borderTopLeftRadius: 10 },
            "& th:last-of-type": { borderTopRightRadius: 10 },
          }}
        >
          <TableRow>
            <TableCell sx={{ minWidth: 200 }}>Datetime</TableCell>
            <TableCell sx={{ minWidth: 240 }}>Admin</TableCell>
            <TableCell>Activity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((log) => (
            <TableRow
              key={`${log.id}-${log.created_datetime}`}
              hover
              sx={{
                "&:hover": { backgroundColor: "rgba(15, 23, 42, 0.02)" },
              }}
            >
              <TableCell>{formatDateTime(log.created_datetime)}</TableCell>
              <TableCell>
                <Typography fontWeight={700}>{log.admin_name || "-"}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {log.admin_email || "—"}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{log.activity_desc}</Typography>
                <Typography variant="caption" color="text.secondary">
                  Result: {log.activity_result}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
          {!rows.length && (
            <TableRow>
              <TableCell colSpan={3}>
                <Typography align="center" color="text.secondary" sx={{ py: 4 }}>
                  No audit entries match the selected criteria.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AuditTable;
